import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import TextField from 'ui/TextField';

/**
 * Компонент-обертка для интеграции компонента TextField с библиотекой react-hook-form.
 * Упрощает использование TextField в формах, управляемых через react-hook-form.
 *
 * @param {string} name - Имя поля в форме (обязательный параметр)
 * @param {string} className - список классов стилей
 * @param {string} label - Видимое название поля пользователю
 * @param {boolean} [required=false] - Флаг указывающий на обязательность заполнения поля
 * @param {Object} rules - Правила валидации для react-hook-form
 * @param {string} type - Тип поля
 * @param {string} placeholder - Текст для отображения, когда ничего не введено
 * @param {Object[]} rest - Остальные вспомогательные св-ва input
 * @param {boolean} hideErrorBlock - скрыть блок для ошибки
 **/
export const FormTextField = ({
  name,
  className = '',
  label = '',
  required = false,
  rules = {},
  type = 'text',
  placeholder = undefined,
  hideErrorBlock = false,
  ...rest
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const formRules = useMemo(() => {
    let defaultRules = {};
    if (required) {
      defaultRules.required = 'Поле обязательно для заполнения';
    }

    return { ...defaultRules, ...rules };
  }, [required, rules]);

  return (
    <Controller
      name={name}
      control={control}
      rules={formRules}
      render={({ field: { onChange, value, name } }) => (
        <TextField
          label={label}
          className={className}
          field={value}
          name={name}
          required={required}
          onChange={onChange}
          type={type}
          placeholder={placeholder}
          isFormValidate={!!errors[name]}
          errorMessage={errors[name]}
          hideErrorBlock={hideErrorBlock}
          {...rest}
        />
      )}
    />
  );
};

export default FormTextField;
